module.exports = __webpack_public_path__ + "img/add-circle-blue.633396d5.svg";